export default __webpack_public_path__ + "static/media/img-o-n-video-marketing-in-person.d7a38753.jpg";